import React, { useState,useEffect } from 'react';
import { ComposedChart, Bar, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import Style from "../style/userWallet.module.scss"
import authAxios from '../../../../config/authAxios';
const EarningChart = ({data=[]}) => {
    const [activeIndex, setActiveIndex] = useState(null);
    const maxCoins = Math.max(...data.map(d => d.coins || 0));

        const transformedData = data.map(item => ({
        ...item,
        barHeight: maxCoins, // ✅ All bars same height (max value)
        coins: item.coins,   // ✅ Dots at actual coin value
        volume: item.volume, // Keep original volume
    }));


    // Custom Tooltip - Orange box style
  const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            // Show actual coin value, not bar height
            const actualValue = payload.find(p => p.dataKey === 'coins')?.value || payload[0].value;
            return (
                <div className={Style.custom_tooltip}>
                    {`${actualValue} Coins`}
                </div>
            );
        }
        return null;
    };


    // Custom Dot - Orange circle with white border
    const CustomDot = (props) => {
        const { cx, cy, index } = props;
        const isActive = index === activeIndex;

        // Active dot (larger)
        if (isActive) {
            return (
                <circle
                    cx={cx}
                    cy={cy}
                    r={8}
                    fill="#FF5733"
                    stroke="#fff"
                    strokeWidth={3}
                />
            );
        }
        // Normal dots
        return (
            <circle
                cx={cx}
                cy={cy}
                r={4}
                fill="#FF5733"
                stroke="#fff"
                strokeWidth={2}
            />
        );
    };

    
    // Calculate Y-axis domain
    const getYAxisDomain = () => {
        if (!data || data.length === 0) return [0, 500];
        const domainMax = Math.ceil(maxCoins * 1.2);
        return [0, domainMax || 500];
    };
    return (
        <div className={Style.graph_box}>

            {/* Duration Selector */}
            <div className={Style.duration_selector}>
                <button className={Style.duration_btn}>
                    7d
                </button>
            </div>

            {/* Chart with date labels at bottom */}
            <div className={Style.date_labels}>
                {data.map((item, index) => (
                    <span key={index} className={Style.date_label}>
                        {item.date}
                    </span>
                ))}
            </div>

            {/* Chart Area */}
            <div className={Style.chart_wrapper}>
                <ResponsiveContainer width="100%" height={140}>
                    <ComposedChart
                        data={transformedData}
                        margin={{ top: 10, right: 10, left: 10, bottom: 0 }}
                        onMouseMove={(state) => {
                            if (state.isTooltipActive) {
                                setActiveIndex(state.activeTooltipIndex);
                            }
                        }}
                        onMouseLeave={() => {
                            setActiveIndex(data.length - 1);
                        }}
                    >
                        <defs>
                            <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="rgba(252, 252, 253, 0)" stopOpacity={1} />
                                <stop offset="100%" stopColor="#FFD6C5" stopOpacity={1} />
                            </linearGradient>
                            
                            <linearGradient id="activeBarGradient" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="rgba(252, 252, 253, 0)" stopOpacity={1} />
                                <stop offset="100%" stopColor="#FA5743" stopOpacity={1} />
                            </linearGradient>

                            <linearGradient id="areaGradient" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#FF5733" stopOpacity={0.2} />
                                <stop offset="95%" stopColor="#FF5733" stopOpacity={0.0} />
                            </linearGradient>
                        </defs>

                        <XAxis
                            dataKey="date"
                            hide={true}
                        />
                        <YAxis hide={true} domain={getYAxisDomain()} />

                        <Tooltip
                            content={<CustomTooltip />}
                            cursor={false}
                            position={{ y: 0 }}
                            active={activeIndex !== null}
                            coordinate={{ x: 0, y: 0 }}
                        />
                        {/* <Bar
                            dataKey="volume"
                            radius={[8, 8, 0, 0]}
                            barSize={17}
                        >
                            {data.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={index === data.length - 1 ? 'url(#activeBarGradient)' : 'url(#barGradient)'}
                                />
                            ))}
                        </Bar> */}
                            <Bar
                            dataKey="barHeight"  // ✅ Using max value for all bars
                            radius={[8, 8, 0, 0]}
                            barSize={17}
                        >
                            {transformedData.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={index === transformedData.length - 1 ? 'url(#activeBarGradient)' : 'url(#barGradient)'}
                                />
                            ))}
                        </Bar>
                        <Area
                            dataKey="coins"
                            stroke="#FF5733"
                            strokeWidth={2}
                            fill="url(#areaGradient)"
                            dot={<CustomDot />}
                            activeDot={{ r: 10, fill: '#FF5733', stroke: '#fff', strokeWidth: 3 }}
                        />
                    </ComposedChart>
                </ResponsiveContainer>
            </div>

        </div>
    );
};

export default EarningChart;